import useStateControls from '../../../../../hooks/useStateControls';
import { START } from '../../../../../constants/shared/states/names';
import { useSharePreloadPromises } from './useSharePreloadPromises';

export default function useToNextState() {
  const preloadPromises = useSharePreloadPromises();
  const { setState } = useStateControls();

  return async () => {
    await preloadPromises();
    setState(START);
  };
}
